import React, { useEffect } from "react"
import { LuCheck } from "react-icons/lu"
import { useLocation, useNavigate, useParams } from "react-router-dom"

// Import CSS module
import BackgroundWrapper from "@fuse/sharedComponents/backgroundWrapper"
import BlurWrapper from "@fuse/sharedComponents/blurWrapper"
import SolidBtn from "@fuse/sharedComponents/buttons/SolidBtn"
import { get } from "lodash-es"
import { ROUTES } from "src/App"

import SuccessShower from "@fuse/assets/images/eventSignUp/img-success-shower.svg"

import styles from "../../eventSignUp/BuyTickets/StripeSuccess/SuccessAnimation.module.css"

const EventCreateSuccess: React.FC = () => {
  //   const { show, flyerImage, onContinueToEvent, textToShow } = useStripeSuccess()
  const { state } = useLocation()
  const navigate = useNavigate()
  const flyerImage = get(
    state,
    "flyerImage",
    "@assets/images/alpha_dark_bg.png",
  )
  const eventName = get(state, "eventName", "")
  useEffect(() => {
    if (!state?.eventId) {
      // Clear navigation state and redirect
      window.history.replaceState({}, document.title)
      navigate(ROUTES.LANDING, { replace: true })
    }
  }, [state])

  return (
    <BackgroundWrapper bgImage={flyerImage} className="min-h-screen">
      <BlurWrapper
        overlayOpacityDefault="75"
        overlayColorDefault="dark"
        className="min-h-screen items-center justify-center flex"
      >
        <div className="flex items-center justify-center flex-col">
          <div className="h-28 w-28 md:h-32 md:w-32 rounded-full bg-white/15 flex items-center justify-center max-w-sm md:max-w-lg">
            <img
              src={SuccessShower}
              alt="SuccessShower"
              className={`absolute h-60 w-60 md:h-80 md:w-80 mr-4 transition-all duration-1000 ease-out
          ${"opacity-100 visibility-visible " + styles.animateScaleUpFromCenter}
        `}
            />
            <div className="h-20 w-20 md:h-24 md:w-24 rounded-full bg-white/15 flex items-center justify-center">
              <LuCheck className="h-14 w-14 md:h-20 md:w-20" color="white" />
            </div>
          </div>

          <div
            className={`max-w-sm md:max-w-lg mt-20 transition-all duration-500 px-4 ease-out
          ${"opacity-100 visibility-visible " + styles.animateScaleUpFromCenter}
        `}
          >
            <p className="text-2xl md:text-3xl text-white">
              {`Event published successfully!`}
            </p>
            <p className="text-sm md:text-md text-white/30 mt-2 max-w-sm">
              {`Your event "${eventName}" has been created! You can now manage it and invite people to join, via the Let's Hang app.`}
            </p>
          </div>

          <div
            className={`flex items-center justify-center mt-10 max-w-xs md:max-w-lg w-full self-center transition-all duration-500 ease-out
          ${"opacity-100 visibility-visible " + styles.animateScaleUpFromCenter}
        `}
          >
            <SolidBtn
              size="lg"
              className="px-6 lg:px-8 w-full bg-white/15"
              onClick={() => {
                // Clear navigation state
                // window.history.replaceState({}, document.title)
                navigate(ROUTES.EVENTS.replace(":eventId", state?.eventId), {
                  replace: true,
                  state: {
                    from: ROUTES.EVENT_CREATE_SUCCESS,
                  },
                })
              }}
            >
              Continue
            </SolidBtn>
          </div>
        </div>
      </BlurWrapper>
    </BackgroundWrapper>
  )
}

export default EventCreateSuccess
